import { ServiceHelper } from "../../Everou/_services/ServiceHelper";
import { URL_CONSTANTS } from "../../Everou/_constants";

export const PMSOrganizationSettingsService = {
    update,
    uploadVideo,
    deleteVideo,
};

// Location defaults deliberately use the location endpoints. Backend applies
// the same validation and distinguishes the template by organization_uid;
// concrete location overrides keep using loc_uid.
function update(organizationUid: string, fields: Record<string, unknown>) {
    return ServiceHelper.postRequest(URL_CONSTANTS.LOCATION_UPDATE, {
        organization_uid: organizationUid,
        ...fields,
    });
}

function videoUrl(organizationUid: string) {
    return `${URL_CONSTANTS.LOCATION_VIDEO_UPLOAD}?organization_uid=${encodeURIComponent(
        organizationUid,
    )}`;
}

function uploadVideo(organizationUid: string, video: any) {
    return ServiceHelper.putVideoRequest(videoUrl(organizationUid), video);
}

function deleteVideo(organizationUid: string) {
    return ServiceHelper.deleteRequest(URL_CONSTANTS.LOCATION_VIDEO_DELETE, {
        organization_uid: organizationUid,
    });
}
